/*
 * @Author: liyxt
 * @Date: 2020-04-07 11:41:26
 * @LastEditors: bbqin
 * @LastEditTime: 2023-11-03 18:06:27
 * @Description: file content
 */
import { getGlobalStorage } from './storage';
import { getParentWindow, getTopWindow } from './window.js';
import { default as PubSub } from 'pubsub-js';
import Color from 'color';

/**
 * @namespace Theme
 */

const entries = ['api', 'base', 'form', 'table-core', 'card-table', 'edit-table', 'simple-table', 'transfer-table', 'tree-table', 'components'];
let DEFAULT_TYPES = ['default', 'default1', 'red', 'green', 'black', 'blue', 'yellow', 'mixin'];

// 将16进制颜色转换为 HSL 颜色
export function hexToHsl(hex) {
    if (!hex) {
        return {
            h: null,
            s: null,
            l: null,
        };
    }
    hex = hex.substring(1);
    hex = hex.length === 3 ? hex + hex : hex;
    // 将16进制颜色转换为RGB颜色
    const r = parseInt(hex.substring(0, 2), 16) / 255;
    const g = parseInt(hex.substring(2, 4), 16) / 255;
    const b = parseInt(hex.substring(4, 6), 16) / 255;

    // 计算最大值和最小值
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);

    // 计算亮度、饱和度和色相
    const l = (max + min) / 2;
    const s = max === min ? 0 : l > 0.5 ? (max - min) / (2 - max - min) : (max - min) / (max + min);
    const h = max === min ? 0
        : max === r
            ? ((g - b) / (max - min) + (g < b ? 6 : 0)) / 6
            : max === g
                ? ((b - r) / (max - min) + 2) / 6
                : ((r - g) / (max - min) + 4) / 6;

    // 将色相、饱和度和亮度转换为HSL颜色
    const hsl = {
        h: Math.round(h * 360),
        s: Math.round(s * 100),
        // 暗黑主题更改传入的背景色  L值改为 22
        l: Math.round(l * 100),
    };

    return hsl;
}

/**
 * 获取当前的主题名，默认是异步获取
 * @memberof Theme
 * @param {boolean} isPromise - 是否异步加载
 * @returns {string|promise}
 */
function getTheme(isPromise = true) {
    let themeName = (window && window.nccColor) || (window && getTopWindow() && getTopWindow().nccColor) || getGlobalStorage('localStorage', 'nccColor') || '';

    return !isPromise
        ? themeName
        : new Promise(function (resolve) {
            // ... some code
            let themeType = (window && window.nccColor) || (window && getTopWindow() && getTopWindow().nccColor) || getGlobalStorage('localStorage', 'nccColor');
            if (themeType) {
                resolve(themeType);
            } else {
                console.log('未能获取到数据 暂时没有加ajax操作！');
                resolve('');
                // reject(new Error('error'));
            }
        });
}

function isJSON(str) {
    if (typeof str == 'string') {
        try {
            var obj = JSON.parse(str);
            if (typeof obj == 'object' && obj) {
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.log('error：' + str + '!!!' + e);
            return false;
        }
    }
    console.log('It is not a string!');
}

/**
 * 获取当前的主题信息，默认是异步获取
 * @memberof Theme
 * @param {boolean} isPromise - 是否异步加载
 * @returns {string|promise}
 */
function getThemeInfo(isPromise = true) {
    if (!isPromise) {
        const themeName = (window && window.nccColor) || (window && getTopWindow() && getTopWindow().nccColor) || getGlobalStorage('localStorage', 'nccColor') || '';
        let themeInfo = getGlobalStorage('localStorage', 'nccTheme');
        themeInfo = isJSON(themeInfo) ? JSON.parse(themeInfo) : themeInfo;
        themeInfo = themeInfo || (window && window.nccTheme) || (window && getTopWindow() && getTopWindow().nccTheme) || {};
        themeInfo.type = themeInfo.type || themeName;
        return themeInfo;
    }

    return new Promise(function (resolve) {
        // ... some code
        const themeName = (window && window.nccColor) || (window && getTopWindow() && getTopWindow().nccColor) || getGlobalStorage('localStorage', 'nccColor') || '';
        let themeInfo = getGlobalStorage('localStorage', 'nccTheme');
        themeInfo = isJSON(themeInfo) ? JSON.parse(themeInfo) : themeInfo;
        themeInfo = themeInfo || (window && window.nccTheme) || (window && getTopWindow() && getTopWindow().nccTheme) || {};
        themeInfo.type = themeInfo.type || themeName;

        const { type } = themeInfo;
        if (type) {
            resolve(themeInfo);
        } else {
            console.log('未能获取到数据 暂时没有加ajax操作！');
            resolve('');
            // reject(new Error('error'));
        }
    });
}

/**
 * 根据fileName获取匹配CSS文件地址列表
 * @ignore
 * @memberof Theme
 * @param {Array} cssList CSS文件列表
 * @param {String} name 文件名
 */
function getFileList(cssList, name) {
    let matchFileList = [];
    for (let i = 0; i < cssList.length; i++) {
        let url = cssList[i];
        let fileName = url.substring(url.lastIndexOf('/') + 1);
        // 可匹配[fileName].css
        // [fileName]-[themeType].css
        // [fileName]-[themeType].[hash]css 等
        let reg = new RegExp(name + '(\\-\\w+)*(\\.\\w+)*\\.css$');
        if (reg.test(fileName)) {
            matchFileList.push(url);
        }
    }
    return matchFileList;
}

/**
 * @ignore
 * @memberof Theme
 * @param {string} baseName
 */
function setBodyNoThemeClass(baseName) {
    if (document && document.body) {
        let reg = new RegExp('' + `${baseName}-(\\w+)*`, 'g'),
            str = String(document.body.className);

        str.replace(/nc-no-theme/gi, '');
        str += ' nc-no-theme default-bg';

        str = str.replace(reg, '');
        document.body.className = str.replace('beautiful-g-transforms', '');
    }
}

/**
 * @ignore
 * @memberof Theme
 * @param {string} mixinColor  混淆的颜色
 * @param {number} alpha alpha 变量
 * @param {string} bg  背景色
 * @returns {string}
 */
function mixinFreeColor(mixinColor, alpha, bg = '#fff') {
    let colroBG = Color(bg).object();
    // let colorRGB = Color(mixinColor).rgb().array();
    let colorRGB = Color(mixinColor).object();
    if (!colorRGB) {
        return mixinColor;
    }

    let rColor = Number((1 - alpha) * colroBG.r + alpha * colorRGB.r).toFixed(0);
    let gColor = Number((1 - alpha) * colroBG.g + alpha * colorRGB.g).toFixed(0);
    let bColor = Number((1 - alpha) * colroBG.b + alpha * colorRGB.b).toFixed(0);

    let color = {
        r: rColor,
        g: gColor,
        b: bColor,
    };
    // console.log(Color, Color(color));
    return Color(color).hex();
}

const defaultContrastRatio = 3; // 4.5

/**
 * 获取对比度符合标准的字体颜色
 * @ignore
 * @memberof Theme
 * @param {string} baseColor
 * @returns {string}
 */
function getContrastFontColor(baseColor, bg = '#fff', shallow = '#fff', deep = '#111') {
    // from 1 (same color) to 21 (contrast b/w white and black)
    const contrastRatioWhite = Color(baseColor).contrast(Color(bg));
    // const contrastRatioBlack = Color(baseColor).contrast(Color(deep));
    // > 4.5 用白色   小于4.5用黑色
    let color = contrastRatioWhite > defaultContrastRatio ? shallow : deep;
    return color;
}

function getVars(themeType, mixinColor, tableTheme) {
    let globalTableConfig = JSON.parse(getGlobalStorage('localStorage', 'nccTable')) || {};
    let vars = {};
    switch (themeType) {
        case 'mixin':
            // const mixin = (mixinColor, weight, baseColor = 'white') => {
            //     return Color(mixinColor).mix(Color(baseColor), weight).hex();
            // };
            // const mixin = (mixinColor, saturation, lightness) => {
            //     // let color = Color(mixinColor).hsl();
            //     // lighten  darken  lightness
            //     // saturate desaturate grayscale
            //     return Color(mixinColor).lighten(lightness).saturate(saturation).hex();
            // };
            let color1 = mixinFreeColor(mixinColor, 0.8, '#fff');
            let color2 = mixinFreeColor(mixinColor, 0.6, '#fff');
            let color3 = mixinFreeColor(mixinColor, 0.4, '#fff');
            let color4 = mixinFreeColor(mixinColor, 0.3, '#fff');
            let color5 = mixinFreeColor(mixinColor, 0.2, '#fff');
            let color6 = mixinFreeColor(mixinColor, 0.1, '#fff');
            let color7 = mixinFreeColor(mixinColor, 0.05, '#fff');

            vars = {
                // 主色
                '--pui-theme-color': mixinColor,
                // 辅色1
                '--pui-derived-color-1': color1,
                // 辅色2
                '--pui-derived-color-2': color2,
                // 辅色3
                '--pui-derived-color-3': color3,
                // 辅色4
                '--pui-derived-color-4': color4,
                // 辅色5
                '--pui-derived-color-5': color5,
                // 辅色6
                '--pui-derived-color-6': color6,
                // 辅色7
                '--pui-derived-color-7': color7,
                // 辅色8
                '--pui-derived-color-8': color7,
                // 辅色9
                '--pui-derived-color-9': color7,
                // 辅色10
                '--pui-derived-color-10': 'none',
                // 对比色1
                '--pui-derived-contrast-color': getContrastFontColor(mixinColor),
                // 对比色1
                '--pui-derived-contrast-color-1': getContrastFontColor(color1),
                // 对比色2
                '--pui-derived-contrast-color-2': getContrastFontColor(color2),
                // 对比色3
                '--pui-derived-contrast-color-3': getContrastFontColor(color3),
                // 对比色4
                '--pui-derived-contrast-color-4': getContrastFontColor(color4),
                // 对比色5
                '--pui-derived-contrast-color-5': getContrastFontColor(color5),
                // 对比色6
                '--pui-derived-contrast-color-6': getContrastFontColor(color6),
                // 对比色7
                '--pui-derived-contrast-color-7': getContrastFontColor(color7),
                // 对比色8
                '--pui-derived-contrast-color-8': getContrastFontColor(color7),
                // 对比色9
                '--pui-derived-contrast-color-9': getContrastFontColor(color7),
                // 翻转1
                '--pui-derived-reverse-color': getContrastFontColor(mixinColor, '#fff', mixinColor, '#333'),
                // 翻转4
                '--pui-derived-reverse-color-4': getContrastFontColor(color4, '#fff', color4, '#888'),
            };
            // 特殊处理  如果对比度正常则取当前颜色  否则用默认颜色
            // let reverseColor = getContrastFontColor(mixinColor, '#fff', mixinColor, '');
            // if (reverseColor) {
            //     vars['--pui-derived-reverse-color'] = reverseColor;
            // }
            // console.log('符合对比度的主题字体颜色', vars);
            break;
        case 'black':
            vars = {
                '--pui-black-theme-color': '#e14c46',
                // 辅色1
                '--pui-black-derived-color-1': '#d7332c',
                // 辅色2
                '--pui-black-derived-color-2': '#292930',
                // 辅色3
                '--pui-black-derived-color-3': '#494954',
                // 辅色4
                '--pui-black-derived-color-4': '#8b3d3a',
                // 辅色5
                '--pui-black-derived-color-5': '#39393f',
                // 辅色6
                '--pui-black-derived-color-6': '#35353c',
                // 辅色7
                '--pui-black-derived-color-7': '#2e2e33',
                // 辅色8
                '--pui-black-derived-color-8': '#46464d',
                // 辅色9
                '--pui-black-derived-color-9': '#25252a',
                // 辅色10
                '--pui-black-derived-color-10': '#1a1a1c',
                // 辅色11
                '--pui-black-derived-color-11': '#0f0f0f',
                // 辅色12
                '--pui-black-derived-color-12': '#52525e',
                // 辅色13
                '--pui-black-derived-color-13': '#5f5f6b',
                // 辅色14
                '--pui-black-derived-color-14': '#696979',

                // 15
                '--pui-black-derived-color-15': '#432B2E',
                // 辅色16
                '--pui-black-derived-color-16': '#474643',
                // 辅色17
                '--pui-black-derived-color-17': '#583718',
                //辅色18
                '--pui-black-derived-color-18': '#BAA70F',
                //辅色19
                '--pui-black-derived-color-19': '#E6A57D',
                //辅色20
                '--pui-black-derived-color-20': '#EAEAEA',
                // 辅色21
                '--pui-black-derived-color-21': '#e23',
                // 文字1
                '--pui-black-font-color-1': '#b0b0b0',
                // 文字2
                '--pui-black-font-color-2': '#c9c9c9',
                // 文字3
                '--pui-black-font-color-3': '#d9d9d9',
                // 文字4
                '--pui-black-font-color-4': '#a5a5a5',
                // 文字5
                '--pui-black-font-color-5': '#888888',
                // 文字6
                '--pui-black-font-color-6': '#f1f1f1',
                // 超链接
                '--pui-black-hyperlink-color': '#5790ff',
                // 蓝色2
                '--pui-black-light-color-2': '#a3c2ff',
                // 蒙层
                '--pui-black-mask-color': 'rgba(0, 0, 0, 0.5)',
                // 投影
                '--pui-black-box-shadow': 'none',
                // 投影1
                '--pui-black-box-shadow-1': '0px 2px 5px 1px rgba(0, 0, 0, 0.5)',
                // 投影2
                '--pui-black-box-shadow-2': '0px -2px 3px 0px hsla(0, 0%, 7%, 0.5)',
                // 透明
                '--pui-black-derived-color-transparent': 'transparent',
                // 图片
                '--pui-black-derived-img-opacity': '0.8',
                // 辅色11
                '--pui-derived-color-11': '#35353c',
                //表格空状态
                '--empty-table-container-background-img': 'none',
                '--empty-table-container-background-color': '#2E2E33',
            };
            break;
        case 'red':
            vars = {
                // 主色
                '--pui-theme-color': '#e14624',
                // 辅色1
                '--pui-derived-color-1': '#d7401e',
                // 辅色2
                '--pui-derived-color-2': '#ff937a',
                // 辅色3
                '--pui-derived-color-3': '#ffbaab',
                // 辅色4
                '--pui-derived-color-4': '#ffccc0',
                // 辅色5
                '--pui-derived-color-5': '#fae5e1',
                // 辅色6
                '--pui-derived-color-6': '#fcebe8',
                // 辅色7
                '--pui-derived-color-7': '#fff4f2',
                // 辅色8
                '--pui-derived-color-8': '#fffaf7',
                // 辅色9
                '--pui-derived-color-9': '#edf0f8',
                // 辅色10
                '--pui-derived-color-10': 'none',
                // 辅色11
                '--pui-derived-color-11': '#bd381a',
            };
            break;
        case 'green':
            vars = {
                // 主色
                '--pui-theme-color': '#08964a',
                // 辅色1
                '--pui-derived-color-1': '#069346',
                // 辅色2
                '--pui-derived-color-2': '#59a97e',
                // 辅色3
                '--pui-derived-color-3': '#7acb9f',
                // 辅色4
                '--pui-derived-color-4': '#8dd9b0',
                // 辅色5
                '--pui-derived-color-5': '#dcf2e7',
                // 辅色6
                '--pui-derived-color-6': '#e8f5ee',
                // 辅色7
                '--pui-derived-color-7': '#f0fff7',
                // 辅色8
                '--pui-derived-color-8': '#f7fffa',
                // 辅色9
                '--pui-derived-color-9': '#edf0f8',
                // 辅色10
                '--pui-derived-color-10': 'none',
                // 辅色11
                '--pui-derived-color-11': '#1f7a4a',
            };
            break;
        case 'blue':
            vars = {
                // 主色
                '--pui-theme-color': '#2665d6',
                // 辅色1
                '--pui-derived-color-1': '#2271e1',
                // 辅色2
                '--pui-derived-color-2': '#589dff',
                // 辅色3
                '--pui-derived-color-3': '#80b4ff',
                // 辅色4
                '--pui-derived-color-4': '#9ac1f8',
                // 辅色5
                '--pui-derived-color-5': '#e3ebfc',
                // 辅色6
                '--pui-derived-color-6': '#e7eefc',
                // 辅色7
                '--pui-derived-color-7': '#f0f5ff',
                // 辅色8
                '--pui-derived-color-8': '#f2f7ff',
                // 辅色9
                '--pui-derived-color-9': '#edf0f8',
                // 辅色10
                '--pui-derived-color-10': 'none',
                // 辅色11
                '--pui-derived-color-11': '#28589f',
            };
            break;
        case 'yellow':
            vars = {
                // 主色
                '--pui-theme-color': '#dB9340',
                // 辅色1
                '--pui-derived-color-1': '#cf8329',
                // 辅色2
                '--pui-derived-color-2': '#f6ba76',
                // 辅色3
                '--pui-derived-color-3': '#f2c896',
                // 辅色4
                '--pui-derived-color-4': '#f6d4ac',
                // 辅色5
                '--pui-derived-color-5': '#f5e3ce',
                // 辅色6
                '--pui-derived-color-6': '#f5e9db',
                // 辅色7
                '--pui-derived-color-7': '#faf4ed',
                // 辅色8
                '--pui-derived-color-8': '#fffaf5',
                // 辅色9
                '--pui-derived-color-9': '#edf0f8',
                // 辅色10
                '--pui-derived-color-10': 'none',
                // 辅色11
                '--pui-derived-color-11': '#a47238',
            };
            break;
        case 'default1':
            vars = {
                // 辅色10
                '--pui-derived-color-10': 'none',
            };
            break;
            vars = {
                '--pui-black-theme-color': 'initial',
                // 辅色1
                '--pui-black-derived-color-1': 'initial',
                // 辅色2
                '--pui-black-derived-color-2': 'initial',
                // 辅色3
                '--pui-black-derived-color-3': 'initial',
                // 辅色4
                '--pui-black-derived-color-4': 'initial',
                // 辅色5
                '--pui-black-derived-color-5': 'initial',
                // 辅色6
                '--pui-black-derived-color-6': 'initial',
                // 辅色7
                '--pui-black-derived-color-7': 'initial',
                // 辅色8
                '--pui-black-derived-color-8': 'initial',
                // 辅色9
                '--pui-black-derived-color-9': 'initial',
                // 辅色10
                '--pui-black-derived-color-10': 'initial',
                // 辅色11
                '--pui-black-derived-color-11': 'initial',
                // 辅色12
                '--pui-black-derived-color-12': 'initial',
                // 辅色13
                '--pui-black-derived-color-13': 'initial',
                // 辅色14
                '--pui-black-derived-color-14': 'initial',
                // 15
                '--pui-black-derived-color-15': 'initial',
                // 辅色16
                '--pui-black-derived-color-16': 'initial',
                // 辅色17
                '--pui-black-derived-color-17': 'initial',
                //辅色18
                '--pui-black-derived-color-18': 'initial',
                //辅色19
                '--pui-black-derived-color-19': 'initial',
                //辅色20
                '--pui-black-derived-color-20': 'initial',
                // 文字1
                '--pui-black-font-color-1': 'initial',
                // 文字2
                '--pui-black-font-color-2': 'initial',
                // 文字3
                '--pui-black-font-color-3': 'initial',
                // 文字4
                '--pui-black-font-color-4': 'initial',
                // 文字5
                '--pui-black-font-color-5': 'initial',
                // 文字6
                '--pui-black-font-color-6': 'initial',
                // 超链接
                '--pui-black-hyperlink-color': 'initial',
                // 蓝色2
                '--pui-black-light-color-2': 'initial',
                // 蒙层
                '--pui-black-mask-color': 'initial',
                // 投影
                '--pui-black-box-shadow': 'none',
                // 投影1
                '--pui-black-box-shadow-1': '0px 2px 5px 1px rgba(0, 0, 0, 0.5)',
                // 投影2
                '--pui-black-box-shadow-2': '0px -2px 3px 0px hsla(0, 0%, 7%, 0.5)',
                // 透明
                '--pui-black-derived-color-transparent': 'transparent',
                // 图片
                '--pui-black-derived-img-opacity': '0.8',
                // 辅色11
                '--pui-derived-color-11': '#35353c',
                //表格空状态
                '--empty-table-container-background-img': 'none',
                '--empty-table-container-background-color': '#2E2E33',
            };
            break;
        default:
            break;
    }
    //计算表格的行选中和表头主题色
    let selectRowColor,
        headerColor,
        tableCellDisabledColor,
        selectTableCellDisabledColor,
        hoverTableCellDisabledColor;

    if (themeType === 'black') {
        selectRowColor = vars['--pui-black-derived-color-8'];
        headerColor = vars['--pui-black-derived-color-6'];
    } else {
        selectRowColor = getColor('--pui-derived-color-5', '#e9f0fa');
        headerColor = getColor('--pui-derived-color-6', '#F7F9FD');
    }

    let { selectedrowcolor = 'light', tablehdbgcolor = 'light' } = { ...globalTableConfig, ...tableTheme };

    function getHslColor(color, level) {
        let hslColor, h, s, l;
        hslColor = hexToHsl(color);
        h = hslColor.h;
        s = hslColor.s;
        if (level === "norm") {
            l = themeType === 'black' ? hslColor.l + 3 : hslColor.l - 3;
        } else if (level === "dark") {
            l = themeType === 'black' ? hslColor.l + 6 : hslColor.l - 6;
        } else {
            l = hslColor.l;
        }
        return `hsl(${h}deg,${s}%,${l}%)`;
    }

    function getDisabledSelectColor(color) {
        let { h, s, l } = hexToHsl(color);

        if (s > 20) {
            s = 20;
        } else if (s > 10) {
            s = 10;
        }

        return `hsl(${h}deg,${s}%,${l - 5}%)`;
    }

    function getDisabledHoverColor(color) {
        let { h, s, l } = hexToHsl(color);

        if (s > 30) {
            s = 30;
        } else if (s > 10) {
            s -= 10;
            s = Math.max(10, s);
        }

        return `hsl(${h}deg,${s}%,${l - 4}%)`;
    }

    function getColor(cssVar, defaultColor) {
        let varValue = vars[cssVar];
        return (!varValue || varValue === "initial") ? defaultColor : varValue;
    }

    vars['--theme-select-row'] = getHslColor(selectRowColor, selectedrowcolor);
    vars['--theme-header'] = getHslColor(headerColor, tablehdbgcolor);
    vars['--theme-select-table-cell-disabled'] = themeType === 'black' ? '#5F6068' : getDisabledSelectColor(selectRowColor);
    vars['--theme-hover-table-cell-disabled'] = themeType.startsWith('default') ? '#e5e5e5' :
        themeType === 'black' ? '#575760' :
            getDisabledHoverColor(
                getColor(
                    '--pui-black-derived-color-7',
                    getColor('--pui-derived-color-7', ''),
                )
            );

    return vars;
}

// 根据主题名称获取var
function setVarsByThemeName(themeType, mixinColor, { selector = ':root', tableTheme = {} } = {}) {
    const allVars = {
        '--pui-black-theme-color': '#e14c46',
        // 辅色1
        '--pui-black-derived-color-1': '#d7332c',
        // 辅色2
        '--pui-black-derived-color-2': '#292930',
        // 辅色3
        '--pui-black-derived-color-3': '#494954',
        // 辅色4
        '--pui-black-derived-color-4': '#8b3d3a',
        // 辅色5
        '--pui-black-derived-color-5': '#39393f',
        // 辅色6
        '--pui-black-derived-color-6': '#35353c',
        // 辅色7
        '--pui-black-derived-color-7': '#2e2e33',
        // 辅色8
        '--pui-black-derived-color-8': '#46464d',
        // 辅色9
        '--pui-black-derived-color-9': '#25252a',
        // 辅色10
        '--pui-black-derived-color-10': '#1a1a1c',
        // 辅色11
        '--pui-black-derived-color-11': '#0f0f0f',
        // 辅色12
        '--pui-black-derived-color-12': '#52525e',
        // 辅色13
        '--pui-black-derived-color-13': '#5f5f6b',
        // 辅色14
        '--pui-black-derived-color-14': '#696979',
        // 辅色15
        '--pui-black-derived-color-15': '#432B2E',
        // 辅色16
        '--pui-black-derived-color-16': '#474643',
        // 辅色17
        '--pui-black-derived-color-17': '#583718',
        //辅色18
        '--pui-black-derived-color-18': '#BAA70F',
        //辅色19
        '--pui-black-derived-color-19': '#E6A57D',
        //辅色20
        '--pui-black-derived-color-20': '#EAEAEA',
        // 辅色21
        '--pui-black-derived-color-21': '#e23',
        // 文字1
        '--pui-black-font-color-1': '#b0b0b0',
        // 文字2
        '--pui-black-font-color-2': '#c9c9c9',
        // 文字3
        '--pui-black-font-color-3': '#d9d9d9',
        // 文字4
        '--pui-black-font-color-4': '#a5a5a5',
        // 文字5
        '--pui-black-font-color-5': '#888888',
        // 文字6
        '--pui-black-font-color-6': '#f1f1f1',
        // 超链接
        '--pui-black-hyperlink-color': '#5790ff',
        // 蓝色2
        '--pui-black-light-color-2': '#a3c2ff',
        // 蒙层
        '--pui-black-mask-color': 'rgba(0, 0, 0, 0.5)',
        // 投影
        '--pui-black-box-shadow': 'none',
        // 投影1
        '--pui-black-box-shadow-1': '0px 2px 5px 1px rgba(0, 0, 0, 0.5)',
        // 投影2
        '--pui-black-box-shadow-2': '0px -2px 3px 0px hsla(0, 0%, 7%, 0.5)',
        // 透明
        '--pui-black-derived-color-transparent': 'transparent',
        // 图片
        '--pui-black-derived-img-opacity': '0.8',
        // 主色
        '--pui-theme-color': '#eb5230',
        // 辅色1
        '--pui-derived-color-1': '#d7401e',
        // 辅色2
        '--pui-derived-color-2': '#ff937a',
        // 辅色3
        '--pui-derived-color-3': '#ffbaab',
        // 辅色4
        '--pui-derived-color-4': '#ffccc0',
        // 辅色5
        '--pui-derived-color-5': '#fae5e1',
        // 辅色6
        '--pui-derived-color-6': '#fcebe8',
        // 辅色7
        '--pui-derived-color-7': '#fff4f2',
        // 辅色8
        '--pui-derived-color-8': '#fffaf7',
        // 辅色9
        '--pui-derived-color-9': '#edf0f8',
        // 辅色10
        '--pui-derived-color-10': 'none',
        // 辅色11
        '--pui-derived-color-11': 'transparent',
        // 对比色1
        '--pui-derived-contrast-color': '#111',
        // 对比色1
        '--pui-derived-contrast-color-1': '#111',
        // 对比色2
        '--pui-derived-contrast-color-2': '#111',
        // 对比色3
        '--pui-derived-contrast-color-3': '#111',
        // 对比色4
        '--pui-derived-contrast-color-4': '#111',
        // 对比色5
        '--pui-derived-contrast-color-5': '#111',
        // 对比色6
        '--pui-derived-contrast-color-6': '#111',
        // 对比色7
        '--pui-derived-contrast-color-7': '#111',
        // 对比色8
        '--pui-derived-contrast-color-8': '#111',
        // 对比色9
        '--pui-derived-contrast-color-9': '#111',
        // 翻转1
        '--pui-derived-reverse-color': '#111',
        // 翻转4
        '--pui-derived-reverse-color-4': '#111',

        //表格空状态
        '--empty-table-container-background-img': 'none',
        '--empty-table-container-background-color': 'white',
        '--theme-header': '--pui-derived-color-6',
        '--theme-select-row': '--pui-derived-color-5',
        '--theme-select-table-cell-disabled': '',
        '--theme-hover-table-cell-disabled': '',
    };
    let vars;
    if (themeType.startsWith('initial')) { // 适用于黑色主题内部嵌套其他主题
        const targetType = themeType.split('-')[1] || 'default';
        const initialVars = { ...getVars('black') };
        for (let k in initialVars) {
            initialVars[k] = 'initial';
        }
        vars = { ...initialVars, ...getVars(targetType, mixinColor, tableTheme) };
    } else {
        vars = getVars(themeType, mixinColor, tableTheme);
    }

    var root = document.querySelector(selector);

    // TODO 这里有个问题是，设置一个属性就有可能导致页面刷新一次，所以要想办法只设置一次，但是还要注意不要影响其他人设置的属性
    // 设置下全局变量
    for (const key in allVars) {
        if (Object.hasOwnProperty.call(vars, key)) {
            const element = vars[key];
            root?.style?.setProperty(key, element);
        } else {
            root?.style?.removeProperty(key);
        }
    }
}

/**
 * 设置主题变化的参数
 * @memberof Theme
 * @typedef setThemeConfig
 * @property {string} [themeType=''] - 主题类型，有['default', 'default1', 'red', 'green', 'black', 'blue', 'yellow', 'mixin'] 。
 * @property {array<string>} themeTypes - 所有主题类型，一般不需要更改，默认值['default', 'default1', 'red', 'green', 'black', 'blue', 'yellow', 'mixin']。
 * @property {string} mixinColor - 自由主题颜色，一般配合themeType为mixin时使用。
 * @property {string} [mode=vars] - 主题生效方式， prePack方式是预打包，vars方式是css变量。
 */

/**
 * 设置主题
 * @memberof Theme
 * @param {setThemeConfig} config - 设置主题的参数
 */
function setTheme({ themeType = '', mixinColor, themeTypes, baseName = 'nc-lightapp-front', baseUrl = '/', mode = 'vars' }) {
    // CSS--* var() 不兼容IE
    const isSupported = window.CSS && window.CSS.supports && window.CSS.supports('(--a: 0)');
    //
    themeTypes = themeTypes || (window ? window.themeTypes : []);
    // 清理和去重
    themeTypes = Array.from(new Set(DEFAULT_TYPES.concat(themeTypes)));
    // 处理下 避免失败的加载错误出现
    if (themeType === '""' || themeTypes.indexOf(themeType) === -1 || !themeType) {
        setBodyNoThemeClass(baseName);
        return null;
    }

    // 设置vars
    isSupported && setVarsByThemeName(themeType, mixinColor);

    // 获取head中的外链样式表组
    let domHead = document.getElementsByTagName('HEAD').item(0),
        styleList = domHead.querySelectorAll('link[rel="stylesheet"]'),
        urlList = [],
        themeList = [],
        matchFileURL;

    // 获取href 字符串
    for (let i = 0; i < styleList.length; i++) {
        urlList.push(styleList[i].getAttribute('href'));
    }

    // 获取已加载的主题文件列表
    themeList = getFileList(urlList, baseName);
    let reg = new RegExp(baseName + '(\\-\\w+)*(\\.\\w+)*\\.css$');
    baseUrl = themeList[0] ? themeList[0].replace(reg, '') : baseUrl;

    // 旧的主题
    let oldThemeList = themeList.map(el => {
        let arr = reg.exec(el);
        let currentTheme = arr && arr[1] && arr[1].replace('-', '');
        return currentTheme;
    });

    // 旧主题包含当前主题 不重复渲染
    if (oldThemeList.includes(themeType)) {
        return;
    }

    // 如果head中的样式表中没有对应的文件则向head中写入file
    if (themeTypes.length > 0) {
        // 移除上个主题的全局样式
        let cls = String(document.body.className);
        var replaceReg = new RegExp('' + `${baseName}-\\w+`, 'g');
        // 过下sonar
        if (cls.length > 1000) {
            return;
        }
        // 遗留主题
        cls = cls.replace(replaceReg, '');
        // 特殊要求
        cls = cls.replace('beautiful-g-transforms', '');
        cls = cls.replace('default-bg', '');
        // 直接写入 themeType  会导致 默认覆盖的 的.green样式触发
        if (themeType !== 'default' && themeType !== 'default1') {
            cls += ` ${baseName}-${themeType} beautiful-g-transforms default-bg`;
        } else {
            // default
            cls += ` ${baseName}-${themeType} default-bg`;
        }
        document.body.className = cls;

        // 本地测试用, 如果用vars 会添加className
        mode = getGlobalStorage('localStorage', 'theme_support') || mode;
        if (isSupported && mode === 'vars') {
            return null;
        }

        // 找到匹配的主题路径
        // let matchFileURL = getFileList(themeTypes, `${baseName}-${themeType}.css`);
        matchFileURL =
            themeTypes.find(item => {
                return item == themeType;
            }) || themeType;

        if (!matchFileURL) {
            setBodyNoThemeClass(baseName);
            console.warn('主题文件的文件名格式错误，出现多个或没有样式文件！', matchFileURL, themeTypes, themeType);
            return;
        }

        // 插入新style
        let style = document.createElement('link');
        // 这里暂时没有考虑hash的情况 TODO
        style.href = `${baseUrl}${baseName}-${matchFileURL}.css`;
        style.rel = 'stylesheet';
        // style.type = 'text/css';
        style.onerror = function () {
            setBodyNoThemeClass(baseName);
            console.log('未能加载到样式', `${baseUrl}${baseName}-${matchFileURL}.css`);
        };

        // 拆包的主题适配
        entries.forEach(item => {
            let style = document.createElement('link');
            // 这里暂时没有考虑hash的情况 TODO
            style.href = `${baseUrl}${item}/index-${matchFileURL}.css`;
            style.rel = 'stylesheet';
            // style.type = 'text/css';
            style.onerror = function () {
                // setBodyNoThemeClass(baseName);
                console.log('未能加载到样式', `${baseUrl}${item}/index-${matchFileURL}.css`);
            };
            domHead.appendChild(style);
        });

        style.onload = () => {
            // 渲染之后
            window.requestAnimationFrame(() => {
                // 删除其他主题文件 解决样式闪动问题
                themeList.forEach(el => {
                    let arr = reg.exec(el);
                    let currentTheme = arr && arr[1] && arr[1].replace('-', '');
                    if (currentTheme && el.indexOf(`${baseName}-${currentTheme}`) >= 0 && themeTypes.indexOf(currentTheme) >= 0 && currentTheme !== themeType) {
                        let item = document.querySelectorAll(`link[href='${el}']`)[0];
                        item && item.parentNode.removeChild(item);
                    }
                });

                // 删除主题的拆包适配
                oldThemeList.forEach(themeType => {
                    entries.forEach(item => {
                        let ele = document.querySelectorAll(`link[href='${baseUrl}${item}/index-${themeType}.css']`)[0];
                        ele && ele.parentNode.removeChild(ele);
                    });
                });
            });
        };

        domHead.appendChild(style);
    }
}

/**
 * @ignore
 * @memberof Theme
 * 给body添加字体样式
 */
function addFontClass() {
    let fontClass = (window && window.nccFontSize) || (window && getTopWindow() && getTopWindow().nccFontSize) || getGlobalStorage('localStorage', 'nccFontSize') || '';
    let body = document.body;
    let className = body.className;
    if (fontClass) {
        //先全部移除
        className = className.replace('bodyLarge', '').replace('bodyMedium', '');
        switch (fontClass) {
            // case 'small':
            //     // body.classList.add("bodySmall");
            //     break;
            case 'large':
                className += ' bodyLarge';
                break;
            case 'medium':
                className += ' bodyMedium';
                break;
            default:
                break;
        }
    }
    let fontValue = (window && window.nccFontValue) || (window && getTopWindow() && getTopWindow().nccFontValue) || getGlobalStorage('localStorage', 'nccFontValue') || '';
    if (fontValue) {
        let classValue = 'globel-fontsize-' + fontValue;
        if (className.includes('globel-fontsize-')) {
            className = className.replace(/globel-fontsize-\d{2}/, classValue);
        } else {
            className += ' ' + classValue;
        }
    }
    document.body.className = className;
}

// 主题
class ThemePlugin {
    static prefix = 'theme_';
    static listenerToken = {};
    constructor(props) {
        // 默认值
        this.listenerToken = props.token || {};
        this.prefix = props.prefix || {};
    }

    /**
     * 添加监听,监听主题的localStorage事件（跨页面或者iframe才会触发）
     * @memberof Theme
     * @function addListener
     * @param {string} name - 唯一名称，用于移除
     * @param {function(themeType): void} callback - 主题变化后触发的方法
     */
    addListener(name, callback) {
        // window.addEventListener('storage', () => {
        //     // When local storage changes, dump the list to
        //     // the console.
        // });

        this.listenerToken[this.prefix + name] = this.listenerToken[this.prefix + name] || [];
        if (callback) {
            this.listenerToken[this.prefix + name].push(
                PubSub.subscribe(this.prefix + name, (topic, message) => {
                    console.log('nccColor message change', message);
                    callback(message);
                }),
            );
        }
    }

    /**
     * 移除监听
     * @memberof Theme
     * @function removeListener
     * @param {string} name - 唯一名称，对应添加监听时的名称
     */
    removeListener(name) {
        // window.removeEventListener('storage', () => {
        //     // When local storage changes, dump the list to
        //     // the console.
        // });

        this.listenerToken[this.prefix + name] = this.listenerToken[this.prefix + name] || [];
        this.listenerToken[this.prefix + name].forEach(token => {
            PubSub.unsubscribe(token);
        });
        // 移除
        delete this.listenerToken[this.prefix + name];
    }

    handleStorage = e => {
        let that = this;
        // When local storage changes, dump the list to
        // the console.
        if (String(e.key).match('nccColor')) {
            let themeType = getGlobalStorage('localStorage', e.key);
            let topColor = that.getTheme(false);
            console.log('nccColor  change', themeType, topColor);
            if (topColor !== themeType) {
                // 可能是被禁用的情况
                console.log('主题被禁用了?');
                return;
            }
            themeType = themeType === 'white' ? 'default' : themeType;
            if (themeType !== 'mixin') {
                setTheme({ themeType: themeType, themeTypes: DEFAULT_TYPES, baseName: 'nc-lightapp-front' });
            }
            for (const name in that.listenerToken) {
                PubSub.publish(name, themeType);
            }
        }
    };

    // 启动主题变化监听
    install() {
        // window.addEventListener('storage', this.handleStorage);
        // return this;
    }

    // 关闭
    uninstall() {
        // window.removeEventListener('storage', this.handleStorage);
    }

    setTheme(config) {
        setTheme(config);
        this.handleStorage({ key: 'nccColor' });
    }

    getTheme(isPromise = true) {
        return getTheme(isPromise);
    }

    getThemeInfo(isPromise = true) {
        return getThemeInfo(isPromise);
    }

    mixinFreeColor(...params) {
        return mixinFreeColor(...params);
    }

    getContrastFontColor(...params) {
        return getContrastFontColor(...params);
    }
}

// 单例
function createTheme(defaultConfig = {}) {
    // 为了保证整个页面唯一
    let instance = window._themeInstance;
    return function () {
        if (!instance) {
            // ThemePlugin.listenerToken 共享token
            instance = window._themeInstance = new ThemePlugin({ token: ThemePlugin.listenerToken, prefix: ThemePlugin.prefix, ...defaultConfig });
        }
        return instance;
    };
}

// 单例
const theme = createTheme()();

theme.Theme = ThemePlugin;
theme.createTheme = createTheme;

window && (window.addFontClass = addFontClass);
window && (window.getTheme = theme.getTheme.bind(theme));
window && (window.setTheme = theme.setTheme.bind(theme));
window && (window.setVarsByThemeName = setVarsByThemeName);
// 测试用
window && (window._testTheme = theme);

export { setTheme, getTheme, getThemeInfo, addFontClass, theme };
